export default class SessionController {
	static logout() {
		return fetch(`/accountants/sign_out`, {
			method: 'DELETE',
			credentials: 'same-origin',
		})
	}
}